<template>
  <router-view/>
  <footer>© 2026 Landerpop</footer>
</template>

<style lang="scss">
@use 'assets/scss/style';
</style>